import { graphql, Link, useStaticQuery } from 'gatsby';
import React from 'react';
import { CarouselTouch } from '../../v2024/Carousel/carousel-touch';

const Opinions = ({ lang = 'en', opinions = null, successCases = false }) => {
	const query = useStaticQuery(graphql`
		query {
			opinions: allStrapiOpinions(filter: { in_home: { eq: true } }) {
				edges {
					node {
						name
						job_position
						message
						company_logo_2 {
							name
							alternativeText
							localFile {
								publicURL
								childImageSharp {
									gatsbyImageData(width: 280, placeholder: NONE, formats: [WEBP])
								}
							}
						}
						photo {
							name
							alternativeText
							localFile {
								publicURL
							}
						}
						locale
					}
				}
			}
			success_cases: allStrapiSuccessCases {
				edges {
					node {
						description
						logo {
							alternativeText
							localFile {
								childImageSharp {
									gatsbyImageData(width: 280, placeholder: NONE, formats: [WEBP])
								}
							}
						}
						locale
					}
				}
			}
			helpers: allMarkdownRemark(filter: { frontmatter: { name: { eq: "helpers" } } }) {
				edges {
					node {
						frontmatter {
							lang
							opinions {
								title
								subtitle
								button
							}
						}
					}
				}
			}
		}
	`);
	if (!opinions) {
		if (successCases) {
			opinions = query.success_cases.edges.filter((item) => item.node.locale === lang);
		} else {
			opinions = query.opinions.edges.filter((item) => item.node.locale === lang);
		}
	}
	const helpers = query.helpers.edges.filter((item) => item.node.frontmatter.lang === lang)[0].node.frontmatter;

	const urlKnowledgeCenter = {
		es: '/es/casos-exito',
		en: '/case-studies',
	};

	return (
		<div className="main__section main__section--100 ">
			<div className="container container--gray">
				<div className="container__text">
					<h2>{helpers.opinions.title}</h2>
					<p>{helpers.opinions.subtitle}</p>
				</div>

				<CarouselTouch slides={opinions} showArrows showIndicators useTestimonial />
				<Link to={urlKnowledgeCenter[lang]} className="link--big">
					{helpers.opinions.button}
					<i className="icon-arrow-right"></i>
				</Link>
			</div>
		</div>
	);
};

export default Opinions;
